<template>
	<div class="row d-flex flex-column-reverse flex-lg-row h-100">
		<div class="col-lg-6 col-md-12 mt-md-1 mt-n5 z-index-2">
			<h2 class="page-heading">{{ translations.partners }}</h2>

			<data-selectors :locale="locale" :translations="translations"></data-selectors>

			<accordion :locale="locale" :translations="translations"></accordion>

		</div>
		<div class="col-lg-6 col-md-12 mapa-vlnka mt-0">
			<partners-google-map :apikey="this.apikey" :localization="locale"></partners-google-map>
		</div>
	</div>

</template>

<script>
import DataSelectors from "./DataSelectors";
import Accordion from "./Accordion";
import PartnersGoogleMap from "./PartnersGoogleMap";
import {mapActions} from "vuex";

export default {
	name: "Partners",
	props: ['apikey','locale', 'translations'],
	components: {
		DataSelectors,
		Accordion,
		PartnersGoogleMap,
	},
	methods: {
		...mapActions(['fetchOfficesData']),
	},
	mounted() {
	}
}
</script>

<style scoped>

</style>
